module.exports = __webpack_public_path__ + "img/9-min.06f915c7.jpg";